import { MasterType } from '@/common/model/master/w2Master'

export const masterTypeName = (masterType: MasterType): string => {
  switch (masterType) {
    case MasterType.ORDERS:
      return '受注'
    case MasterType.W2_USER:
      return 'ユーザー'
    case MasterType.W2_USER_ATTRIBUTE:
      return 'ユーザー属性'
    case MasterType.W2_MEMBER_RANK:
      return '会員ランク'
    case MasterType.W2_ACCESS_LOG:
      return 'アクセスログ'
    case MasterType.W2_PRODUCT:
      return '商品'
    case MasterType.W2_PRODUCT_BRAND:
      return 'ブランド'
    case MasterType.W2_PRODUCT_CATEGORY:
      return '商品カテゴリ'
    case MasterType.W2_PRODUCT_TAG:
      return '商品タグ'
    case MasterType.W2_PRODUCT_TAG_SETTING:
      return '商品タグ設定'
    case MasterType.W2_PRODUCT_STOCK:
      return '商品在庫'
    case MasterType.W2_PRODUCT_VARIATION:
      return '商品バリエーション'
    case MasterType.W2_PRODUCT_PRICE:
      return '商品価格'
    case MasterType.W2_CART:
      return 'カート'
    case MasterType.W2_ORDER:
      return '注文'
    case MasterType.W2_ORDER_ITEM:
      return '注文明細'
    case MasterType.W2_ORDER_COUPON:
      return '注文クーポン'
    case MasterType.W2_COUPON:
      return 'クーポン'
    case MasterType.W2_ADV_CODE:
      return '広告コード'
    case MasterType.W2_FEATURE_PAGE:
      return '特集ページ'
    case MasterType.W2_FEATURE_PAGE_CATEGORY:
      return '特集ページカテゴリ'
    case MasterType.W2_FEATURE_PAGE_CONTENTS:
      return '特集ページコンテンツ'
    case MasterType.W2_PRODUCT_GROUP:
      return '商品グループ'
    case MasterType.W2_PRODUCT_GROUP_ITEM:
      return '商品グループアイテム'
    case MasterType.W2_CONTENTS_TAG:
      return 'コンテンツタグ'
    case MasterType.W2_PRODUCT_LINK:
      return '商品リンク'
    // 拡張マスタ（add-w2-ex-product-spec で追加）
    case MasterType.W2_EX_PRODUCT_SPEC:
      return '商品追加情報'
    case MasterType.W2_EX_PRODUCT_VARIATION_SPEC:
      return '商品バリエーション追加情報'
    case MasterType.W2_USER_POINT:
      return 'ユーザポイント'
    case MasterType.W2_USER_POINT_HISTORY:
      return 'ユーザポイント履歴'
    case MasterType.W2_POINT_RULE:
      return 'ポイントルール'
    case MasterType.W2_POINT_RULE_SCHEDULE:
      return 'ポイントルールスケジュール'
    case MasterType.W2_USER_MEMBER_RANK_HISTORY:
      return '会員ランク更新履歴'
    case MasterType.W2_MEMBER_RANK_RULE:
      return '会員ランク付与ルール'
    case MasterType.W2_ORDER_SHIPPING:
      return '注文配送先情報'
    case MasterType.W2_SHOP_SHIPPING:
      return '店舗配送種別'
    case MasterType.W2_SHOP_SHIPPING_ZONE:
      return '店舗配送料地帯'
    case MasterType.W2_SHOP_SHIPPING_SIZE_THRESHOLD:
      return '配送サイズ別上限設定'
    case MasterType.W2_MAIL_DIST_SETTING:
      return 'メール配信設定'
    case MasterType.W2_MAIL_DIST_SENT_USER:
      return 'メール配信送信済ユーザ'
    case MasterType.W2_MAIL_SEND_LOG:
      return 'メール送信ログ'
    case MasterType.W2_MAIL_CLICK:
      return 'メールクリック'
    case MasterType.W2_MAIL_CLICK_LOG:
      return 'メールクリックログ'
    case MasterType.W2_ORDER_WORKFLOW_SCENARIO_SETTING:
      return '受注ワークフローシナリオ設定'
    case MasterType.W2_NOVELTY:
      return 'ノベルティ設定'
    case MasterType.W2_NOVELTY_GRANT_CONDITIONS:
      return 'ノベルティ付与条件'
    case MasterType.W2_NOVELTY_GRANT_ITEM:
      return 'ノベルティ付与アイテム'
    case MasterType.W2_NOVELTY_TARGET_ITEM:
      return 'ノベルティ対象アイテム'
    case MasterType.W2_ORDER_SET_PROMOTION:
      return '注文セットプロモーション'
    case MasterType.W2_ORDER_SET_PROMOTION_ITEM:
      return '注文セットプロモーションアイテム'
    case MasterType.W2_SET_PROMOTION:
      return 'セットプロモーション'
    case MasterType.W2_SET_PROMOTION_ITEM:
      return 'セットプロモーション商品'
    case MasterType.W2_PRODUCT_BUNDLE:
      return '商品同梱'
    case MasterType.W2_PRODUCT_BUNDLE_ITEM:
      return '商品同梱 同梱商品'
    case MasterType.W2_PRODUCT_SET:
      return '商品セット'
    case MasterType.W2_PRODUCT_SET_ITEM:
      return '商品セットアイテム'
    case MasterType.W2_PRODUCT_SALE:
      return '商品セール'
    case MasterType.W2_PRODUCT_SALE_PRICE:
      return '商品セール価格'
    case MasterType.W2_FIXED_PURCHASE:
      return '定期購入情報'
    case MasterType.W2_FIXED_PURCHASE_ITEM:
      return '定期購入商品情報'
    case MasterType.W2_FIXED_PURCHASE_HISTORY:
      return '定期購入履歴情報'
    case MasterType.W2_FIXED_PURCHASE_CANCEL_REASON:
      return '定期解約理由区分設定'
    case MasterType.W2_USER_COUPON:
      return 'ユーザクーポン'
    case MasterType.W2_USER_COUPON_HISTORY:
      return 'ユーザクーポン履歴'
    case MasterType.W2_COUPON_USE_USER:
      return 'クーポン利用ユーザー'
    case MasterType.W2_COUPON_SCHEDULE:
      return 'クーポン発行スケジュール'
    case MasterType.W2_ADV_CODE_LOG:
      return '広告コード流入ログ'
    case MasterType.W2_ADV_CODE_MEDIA_TYPE:
      return '広告媒体区分'
    case MasterType.W2_USER_ACTIVITY:
      return 'ユーザーアクティビティ'
    case MasterType.W2_AB_TEST:
      return 'A/Bテスト'
    case MasterType.W2_AB_TEST_ITEM:
      return 'A/Bテストアイテム'
    case MasterType.W2_PAGE_DESIGN:
      return 'ページデザイン'
    case MasterType.W2_PAGE_DESIGN_GROUP:
      return 'ページデザイングループ'
    case MasterType.W2_PARTS_DESIGN:
      return 'パーツデザイン'
    case MasterType.W2_PARTS_DESIGN_GROUP:
      return 'パーツデザイングループ'
    case MasterType.W2_FEATURE_AREA:
      return '特集エリア'
    case MasterType.W2_FEATURE_AREA_BANNER:
      return '特集エリアバナー'
    case MasterType.W2_POPUP:
      return 'ポップアップ'
    case MasterType.W2_POPUP_DISPLAY_PAGE_SETTING:
      return 'ポップアップ表示ページ設定'
    case MasterType.W2_POPUP_REPORT:
      return 'ポップアップレポート'
  }
  return masterType
}

// データ区分（AppNavigation のセグメントに対応）。マスタ種別→区分の単一ソース。
// 種別追加時は該当グループに追記する（FileUploadPage / MasterSummaryPage が参照）。
export const MASTER_GROUP_ORDER = [
  'ユーザー',
  '商品',
  '受注',
  '広告',
  'コンテンツ',
  '商品グループ',
  '基本',
  'その他'
]

const MASTER_GROUP_TYPES: { group: string; types: MasterType[] }[] = [
  {
    group: 'ユーザー',
    types: [
      MasterType.W2_USER,
      MasterType.W2_USER_ATTRIBUTE,
      MasterType.W2_MEMBER_RANK,
      MasterType.W2_ACCESS_LOG,
      MasterType.W2_USER_POINT,
      MasterType.W2_USER_POINT_HISTORY,
      MasterType.W2_POINT_RULE,
      MasterType.W2_POINT_RULE_SCHEDULE,
      MasterType.W2_USER_MEMBER_RANK_HISTORY,
      MasterType.W2_MEMBER_RANK_RULE,
      MasterType.W2_FIXED_PURCHASE,
      MasterType.W2_FIXED_PURCHASE_ITEM,
      MasterType.W2_FIXED_PURCHASE_HISTORY,
      MasterType.W2_FIXED_PURCHASE_CANCEL_REASON,
      MasterType.W2_USER_ACTIVITY,
      MasterType.W2_MAIL_DIST_SETTING,
      MasterType.W2_MAIL_DIST_SENT_USER,
      MasterType.W2_MAIL_SEND_LOG,
      MasterType.W2_MAIL_CLICK,
      MasterType.W2_MAIL_CLICK_LOG,
      MasterType.W2_ORDER_WORKFLOW_SCENARIO_SETTING
    ]
  },
  {
    group: '商品',
    types: [
      MasterType.W2_PRODUCT,
      MasterType.W2_PRODUCT_LINK,
      // 拡張マスタ（add-w2-ex-product-spec で追加）：商品リンクの直後に置く
      MasterType.W2_EX_PRODUCT_SPEC,
      MasterType.W2_EX_PRODUCT_VARIATION_SPEC,
      MasterType.W2_PRODUCT_BRAND,
      MasterType.W2_PRODUCT_CATEGORY,
      MasterType.W2_PRODUCT_TAG,
      // 商品タグの列名の定義。商品タグの直後に置く（add-w2-product-tag-setting）
      MasterType.W2_PRODUCT_TAG_SETTING,
      MasterType.W2_PRODUCT_STOCK,
      MasterType.W2_PRODUCT_VARIATION,
      MasterType.W2_PRODUCT_PRICE,
      MasterType.W2_NOVELTY,
      MasterType.W2_NOVELTY_GRANT_CONDITIONS,
      MasterType.W2_NOVELTY_GRANT_ITEM,
      MasterType.W2_NOVELTY_TARGET_ITEM,
      MasterType.W2_PRODUCT_SALE,
      MasterType.W2_PRODUCT_SALE_PRICE
    ]
  },
  {
    group: '受注',
    types: [
      MasterType.W2_CART,
      MasterType.W2_ORDER,
      MasterType.W2_ORDER_ITEM,
      MasterType.W2_ORDER_COUPON,
      MasterType.W2_COUPON,
      MasterType.W2_ADV_CODE,
      MasterType.W2_ORDER_SHIPPING,
      MasterType.W2_SHOP_SHIPPING,
      MasterType.W2_SHOP_SHIPPING_ZONE,
      MasterType.W2_SHOP_SHIPPING_SIZE_THRESHOLD,
      MasterType.W2_ORDER_SET_PROMOTION,
      MasterType.W2_ORDER_SET_PROMOTION_ITEM,
      MasterType.W2_SET_PROMOTION,
      MasterType.W2_SET_PROMOTION_ITEM,
      MasterType.W2_PRODUCT_BUNDLE,
      MasterType.W2_PRODUCT_BUNDLE_ITEM,
      MasterType.W2_PRODUCT_SET,
      MasterType.W2_PRODUCT_SET_ITEM,
      MasterType.W2_USER_COUPON,
      MasterType.W2_USER_COUPON_HISTORY,
      MasterType.W2_COUPON_USE_USER,
      MasterType.W2_COUPON_SCHEDULE
    ]
  },
  {
    group: '広告',
    types: [
      MasterType.W2_ADV_CODE_LOG,
      MasterType.W2_ADV_CODE_MEDIA_TYPE,
      MasterType.W2_AB_TEST,
      MasterType.W2_AB_TEST_ITEM
    ]
  },
  {
    group: 'コンテンツ',
    types: [
      MasterType.W2_FEATURE_PAGE,
      MasterType.W2_FEATURE_PAGE_CATEGORY,
      MasterType.W2_FEATURE_PAGE_CONTENTS,
      MasterType.W2_CONTENTS_TAG,
      MasterType.W2_PAGE_DESIGN,
      MasterType.W2_PAGE_DESIGN_GROUP,
      MasterType.W2_PARTS_DESIGN,
      MasterType.W2_PARTS_DESIGN_GROUP,
      MasterType.W2_FEATURE_AREA,
      MasterType.W2_FEATURE_AREA_BANNER,
      MasterType.W2_POPUP,
      MasterType.W2_POPUP_DISPLAY_PAGE_SETTING,
      MasterType.W2_POPUP_REPORT
    ]
  },
  {
    group: '商品グループ',
    types: [MasterType.W2_PRODUCT_GROUP, MasterType.W2_PRODUCT_GROUP_ITEM]
  },
  {
    group: '受注',
    types: [MasterType.ORDERS]
  }
]

const TYPE_TO_GROUP: Record<string, string> = Object.fromEntries(
  MASTER_GROUP_TYPES.flatMap((g) => g.types.map((t) => [t, g.group]))
)

// マスタ種別→データ区分。AppNavigation・FileUploadPage・MasterSummaryPage で共通利用。
export const masterTypeGroup = (masterType: MasterType): string =>
  TYPE_TO_GROUP[masterType] ?? 'その他'

const TYPE_ORDER: Record<string, number> = Object.fromEntries(
  MASTER_GROUP_TYPES.flatMap((g) => g.types).map((t, i) => [t, i])
)

// マスタ種別の表示順（区分定義 MASTER_GROUP_TYPES の並び順に従う通し番号）。
export const masterTypeOrder = (masterType: MasterType): number => TYPE_ORDER[masterType] ?? 999
